// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"8ac96e90","741":"1a0dab18","782":"1922a939"}[chunkId] + ".chunk.css";
};